(function () {
  var SLIDE_INTERVAL_MS = 4000;

  function initSlideshow(banner) {
    if (banner.dataset.autoSlideshowInit) return;

    var halves = Array.prototype.slice.call(banner.querySelectorAll('.banner__media-half'));
    if (halves.length < 2) return;

    banner.dataset.autoSlideshowInit = 'true';

    // Only sync per-photo buttons (like the two "Shop the Look"
    // buttons, one per image) when there's exactly one button per
    // photo — sections with a single shared button/heading (e.g.
    // "Signature Layers") don't have a 1:1 mapping to toggle.
    var buttons = Array.prototype.slice.call(banner.querySelectorAll('.banner__buttons .button'));
    var syncButtons = buttons.length === halves.length;

    var activeIndex = 0;
    halves.forEach(function (half, index) {
      half.classList.toggle('is-active', index === 0);
    });
    if (syncButtons) {
      buttons.forEach(function (btn, index) {
        btn.classList.toggle('is-active', index === 0);
      });
    }

    setInterval(function () {
      halves[activeIndex].classList.remove('is-active');
      if (syncButtons) buttons[activeIndex].classList.remove('is-active');

      activeIndex = (activeIndex + 1) % halves.length;

      halves[activeIndex].classList.add('is-active');
      if (syncButtons) buttons[activeIndex].classList.add('is-active');
    }, SLIDE_INTERVAL_MS);
  }

  function init() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.banner').forEach(function (banner) {
      if (banner.querySelectorAll('.banner__media-half').length >= 2) {
        initSlideshow(banner);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
